import { render, staticRenderFns } from "./XtModal.vue?vue&type=template&id=b2dbde4a&scoped=true"
import script from "./XtModal.vue?vue&type=script&lang=js"
export * from "./XtModal.vue?vue&type=script&lang=js"
import style0 from "./XtModal.vue?vue&type=style&index=0&id=b2dbde4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dbde4a",
  null
  
)

export default component.exports